import { BigNumber } from 'lk-web3-utils'

export default {
  ZERO_ADDRESS: '0x0000000000000000000000000000000000000000',
  ZERO_BYTES32: "0x0000000000000000000000000000000000000000000000000000000000000000",
  MAX_UINT256: new BigNumber(2).pow(256).minus(1),
}
